import { B2B_ACCOUNT_PROFILE_PATH, B2B_UPDATE_PROFILE_PATH, B2B_TRADE_TYPES_PATH, B2B_PROFILE_PREFERENCE_PATH, } from '../../constants/links';
import { apiB2B } from '../axios-client';
export var b2bAccountApi = {
    profileDetails: function () {
        return apiB2B.get(B2B_ACCOUNT_PROFILE_PATH);
    },
    updateProfileDetails: function (data) {
        return apiB2B.post(B2B_UPDATE_PROFILE_PATH, data);
    },
    updateCompanyDetails: function (data) {
        return apiB2B.put(B2B_UPDATE_PROFILE_PATH, data);
    },
    deleteAltPhone: function (data) {
        return apiB2B.delete(B2B_UPDATE_PROFILE_PATH, {
            data: {
                customerProfile: {
                    phones: data,
                },
            },
        });
    },
    trials: function (_a) {
        var customerSVOCId = _a.customerSVOCId, _b = _a.host, host = _b === void 0 ? '' : _b;
        if (!customerSVOCId) {
            return Promise.reject(new Error('Cannot call trials without custId'));
        }
        return apiB2B.get("".concat(host, "/b2b/user/account/customer/").concat(customerSVOCId, "/features"));
    },
    enrollments: function (_a) {
        var customerUserId = _a.customerUserId, customerSVOCId = _a.customerSVOCId, jwt = _a.jwt, _b = _a.host, host = _b === void 0 ? '' : _b;
        if (!customerSVOCId || !customerUserId || !jwt) {
            return Promise.reject(new Error('Cannot call enrollments without custId or userId or jwt'));
        }
        return apiB2B.get("".concat(host, "/b2b/user/account/").concat(customerUserId, "/customer/").concat(customerSVOCId, "/perks/enrollments"), {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Cookie: "THD_CUSTOMER=".concat(jwt),
            },
        });
    },
    userState: function (_a) {
        var customerUserId = _a.customerUserId, jwt = _a.jwt, _b = _a.host, host = _b === void 0 ? '' : _b;
        if (!jwt || !customerUserId) {
            return Promise.reject(new Error('Cannot call statemanagement without jwt or custId'));
        }
        return apiB2B.get("".concat(host, "/state/v1/user/").concat(customerUserId), {
            headers: {
                Accept: 'application/json',
                Authorization: "Bearer ".concat(jwt),
            },
        });
    },
    getTradeTypes: function () { return apiB2B.get(B2B_TRADE_TYPES_PATH); },
    updateEmailPreference: function (data) {
        return apiB2B.post(B2B_PROFILE_PREFERENCE_PATH, data);
    },
};
